import React from "react";
import Layout from "../../components/layout/Layout";
import AboutUS from "../../components/about/AboutUs";

const About = () => {
  return (
    <Layout>
      <div>
      <AboutUS />
      </div>
    </Layout>
  );
};

export default About;